<template>
  <div class='GiftList' :class="{ gray: isPar(chave) }">
    <div class="col codigo" style="width: 18%">
      {{ data.codigo }}
    </div>
    <div class="col col-tipo" style="width: 16%">
      <div class="tipo">{{ data.tipo }}</div>
    </div>
    <div class="col montante" data-label="Montante" style="width: 16%">
      {{ data.tipo === 'Desconto Percentual' ? data.valor + '%' : data.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}
    </div>
    <div class="col limite" data-label="Limite de uso" style="width: 16%">
      {{ data.limiteCupom === 0 ? '-' : data.limiteCupom }}
    </div>
    <div class="col validade" data-label="Data de validade" style="width: 18%">
      <!-- {{ dateFormat(new Date(parseInt(data.validade)), 'dd-mm-yyyy') === '01-01-1900' ? '-' : dateFormat(new Date(parseInt(data.validade)), 'dd-mm-yyyy') }} -->
        {{ data.validade === '01-01-1900' ? '-' : data.validade }}
    </div>
    <div class="col action" style="width: 16%">
      <edit-icon @click="select"/>
      <!-- <delete-icon @click="del"/> -->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditIcon from '../../Icons/EditIcon'
//import DeleteIcon from '../../Icons/DeleteIcon'
import dateFormat from 'dateformat'
export default {
  name: 'GiftList',
  props: ['data', 'chave'],
  components: { EditIcon },
  data () {
    return {
      dateFormat: dateFormat
    }
  },
  methods: {
    ...mapActions(['SetGiftEdit', 'SetMultiSelect', 'SetModal']),
    select () {
      this.SetMultiSelect({ store: 'ProdutosGift', list: this.data.produtos })
        .then(() => this.SetMultiSelect({ store: 'DelProdutosGift', list: this.data.produtoDel }))
        .then(() => this.SetMultiSelect({ store: 'CategoriasGift', list: this.data.categorias }))
        .then(() => this.SetMultiSelect({ store: 'DelCategoriasGift', list: this.data.categoriasDel }))
        .then(() => this.SetGiftEdit(this.data))
        .then(() => this.$router.push('/painel/gift/update'))
    },
    del () {
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: 'Tem certeza que deseja excluir o cupom?',
        action: 'DeleteGift',
        payload: this.data
      })
    },
    isPar (n) {
      let d = n / 2
      return d % 1 === 0
    }
  }
}
</script>

<style scoped>
.GiftList {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 1%;
}

.action {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tipo {
  background-color: green;
  padding: 2%;
  border-radius: 3px;
  color: #FFFFFF;
}

.gray {
  background-color: #F5F5F5F5;
}

/* mobile: cada cupom vira um cartão (o cabeçalho da tabela fica oculto) */
@media (max-width: 500px) {
  .GiftList {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'codigo   action'
      'tipo     tipo'
      'montante limite'
      'validade validade';
    gap: 10px;
    padding: 14px 4%;
    text-align: left;
  }

  /* as larguras da tabela vêm inline */
  .col {
    width: auto !important;
  }

  .col[data-label]::before {
    content: attr(data-label);
    display: block;
    font-size: 11px;
    color: #888888;
    margin-bottom: 2px;
  }

  .codigo {
    grid-area: codigo;
    font-weight: bold;
    font-size: 16px;
    word-break: break-all;
  }

  .action {
    grid-area: action;
    justify-content: end;
  }

  .col-tipo {
    grid-area: tipo;
  }

  .tipo {
    display: inline-block;
    padding: 3px 8px;
    font-size: 12px;
  }

  .montante { grid-area: montante; }
  .limite { grid-area: limite; }
  .validade { grid-area: validade; }
}
</style>
